import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@material-ui/core/Grid';
import { blueGrey } from '@mui/material/colors';

const Home = () => {
  // const [clickedReg, setClickedReg] = React.useState(false);
  // const [clickedRegBr, setClickedRegBr] = React.useState(false);

  let tg = window.Telegram.WebApp;

  const sendDataToTelegram = (e) => {
    if (e.target.name === 'broker') {
      tg.sendData(`{"clickedRegBr": "clickedRegBr",}`);
    }
    else {
      tg.sendData(`{"clickedReg": "clickedReg",}`);
    }

  }

  useEffect(() => {
    window.scrollTo(0, 0)
    tg.MainButton.hide()
  }, [])

  return (
    <Box sx={{ p: 3 }}>
      <Grid container direction="column" alignItems="center" style={{ justifyContent: "center" }}>
        <h3 sx={{ pb: 3 }}>Приветствуем вас в чат-боте R4S!</h3>
        <p>Чат-бот R4S создан для комфортного взаимодействия с агентствами недвижимости и частными брокерами.</p>
        <p style={{ marginBottom: 0, width: '100%' }}>Функционал бота позволит вам:</p>
        <ul>
          <li>
            Ознакомиться с актуальными регламентами работы и рекламы
          </li>
          <li>
            Оставить заявку на брокер-тур
          </li>
          <li>
            Проверить клиента на уникальность
          </li>
          <li>
            Скачать в один клик презентации, рендеры, фотографии
          </li>
        </ul>
        <p>Если у вас возникнут вопросы по работе чат-бота, <a href='http://wa.me/+79311113196'> напишите нам.</a></p>
        <h4 sx={{ pt: 3 }}>Регламенты взаимодействия c брокерами и агентствами недвижимости</h4>
        <Button sx={{
          color: blueGrey[500],
          borderColor: blueGrey[500],
          '&:hover': { color: blueGrey[500], borderColor: blueGrey[500], }
        }} style={{ width: 350 }} size="small" variant="outlined" name='broker' onClick={sendDataToTelegram}>скачать</Button>
        <h4 sx={{ pt: 3 }}>Регламент взаимодействия с агентствами по рекламе</h4>
        <Button sx={{
          color: blueGrey[500],
          borderColor: blueGrey[500],
          '&:hover': { color: blueGrey[500], borderColor: blueGrey[500], }
        }} style={{ width: 350 }} size="small" variant="outlined" name='reklama' onClick={sendDataToTelegram}>скачать</Button>
      </Grid>
    </Box>
  );
};

export default Home;